import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { onEnter, onExit } from "../../../../config/customModalFunctions";
import { Form, Formik } from 'formik';
import { NOTIFICATION_TICKET_MODAL } from '../../../../config/notifications';
import { RejectTicketForm } from '../forms/RejectTicketForm';
import { Messages } from '../../../layout/Messages/Messages';

function TicketReasonModal(props) {
  const { showModal, closeModal, ticket, resolveTicket } = props;

  const getInitialValues = () => {
    return {
      reason: '',
      ticket: ticket,
    }
  }

  return (
    <Modal
      isOpen={showModal}
      toggle={closeModal}
      onEnter={onEnter}
      onExit={onExit}
      returnFocusAfterClose={false}
      centered
      size="lg"
    >
      <ModalHeader toggle={closeModal}>
        {
          resolveTicket === false ?
          <FormattedMessage id="components.pages.ticket.modals.rejectTicket.title"/> :
          <FormattedMessage id="components.pages.ticket.modals.rejectTicket.title_resolve"/>
        }
      </ModalHeader>
      <ModalBody>
        <Formik
          initialValues={getInitialValues()}
          validateOnChange={true}
          onSubmit={(values) => {
            props.confirmationYes( values );
          }}
        >
          {props => (
            <Fragment>
              <Messages notificationId={NOTIFICATION_TICKET_MODAL}/>
              <Form>
                <RejectTicketForm
                  formikProps={props}
                />

                <div className="text-center text-sm-right py-3 mt-4">
                  <Button
                    className="mt-2 mt-sm-0"
                    name="add"
                    type="submit"
                    color="primary"
                  >
                    <FormattedMessage id="button.confirm"/>
                  </Button>
                  <Button className="mt-2 mt-sm-0" name="cancel" color="primary"
                          onClick={closeModal}>
                    <FormattedMessage id="button.cancel"/>
                  </Button>
                </div>
              </Form>
            </Fragment>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
}

TicketReasonModal.defaultProps = {
  confirmationYes: null,
  showModal: false
};

export { TicketReasonModal };
